// eslint-disable-next-line no-unused-vars
import {createRouter, createWebHashHistory, createWebHistory} from 'vue-router'
import LoginView from "@/views/LoginView";
import SaleIndexView from "@/views/sale/SaleIndexView";
import SaleDetailView from "@/views/sale/SaleDetailView";
import SalePayView from "@/views/sale/SalePayView";
import SaleFillInfoView from "@/views/sale/SaleFillInfoView";
import CustomerOrderListView from "@/views/sale/CustomerOrderListView";
import FillUserInfoView from "@/views/sale/FillUserInfoView";
import AgentOrderListView from "@/views/sale/AgentOrderListView";
import SaleDashboardView from "@/views/sale/SaleDashboardView";
import LianLianPayView from "@/views/llp/LianLianPayView";
import AlipayRedirectView from "@/views/llp/AlipayRedirectView";
import WxPayResultView from "@/views/sale/WxPayResultView";
import AgentCategoryShareView from "@/views/sale/AgentCategoryShareView";
import SaleOrderDetailView from "@/views/sale/SaleOrderDetailView.vue";
import FillInfoAndCreateOrderView from "@/views/sale/FillInfoAndCreateOrderView.vue";
import RefundAuditListView from "@/views/sale/RefundAuditListView.vue";


const routes = [{
    path: '/', name: 'index', component: CustomerOrderListView, meta: {
        auth: true
    }
}, {
    path: "/login", name: "login", component: LoginView
},
//     {
//     path: '/statistic', name: 'events', component: StatisticView, meta: {
//         auth: true, keepAlive: true, title: '数据'
//     }
// }, {
//     path: '/my', name: 'my', component: MyView, meta: {
//         auth: true, title: '我的'
//     }
// },
    {
        path: '/sale', name: 'SaleIndexView', component: SaleIndexView, meta: {
            auth: true, title: '商品列表'
        }
    }, {
        path: '/sale/detail/:lessonId', name: 'SaleDetailView', component: SaleDetailView, meta: {
            auth: true, title: '详情'
        }
    },{
        path: '/sale/create/:goodId/:skuId', name: 'FillInfoAndCreateOrderView', component: FillInfoAndCreateOrderView, meta: {
            auth: true, title: '创建订单'
        }
    },{
        path: '/d/:lessonId', name: 'ShortSaleDetailView', component: SaleDetailView, meta: {
            auth: true, title: '详情'
        }
    }, {
        path: '/sale/lesson/pay/:lessonId', name: 'SalePayView', component: SalePayView, meta: {
            auth: true, title: '支付'
        }
    }, {
        path: '/sale/fill/info/:orderId', name: 'SaleFillInfoView', component: SaleFillInfoView, meta: {
            auth: true, title: '填写信息'
        }
    }, {
        path: '/sale/customer/order/list', name: 'CustomerOrderListView', component: CustomerOrderListView, meta: {
            auth: true, title: '订单列表'
        }
    }, {
        path: '/sale/agent/order/list', name: 'AgentOrderListView', component: AgentOrderListView, meta: {
            auth: true, title: '销售订单列表'
        }
    },{
        path: '/sale/agent/order/detail/:orderId', name: 'SaleOrderDetailView', component: SaleOrderDetailView, meta: {
            auth: true, title: '销售订单详情'
        }
    }, {
        path: '/sale/agent/dashboard', name: 'SaleDashboardView', component: SaleDashboardView, meta: {
            auth: true, title: '个人中心'
        }
    }, {
        path: '/fill/user/info', name: 'FillUserInfoView', component: FillUserInfoView, meta: {
            auth: true, title: '我的信息'
        }
    },{
        path: '/share/:token', name: 'AgentCategoryShareView', component: AgentCategoryShareView, meta: {
            auth: true, title: '分享'
        }
    }, {
        path: '/pay/:orderId', name: 'LianLianPayView', component: LianLianPayView, meta: {
            auth: false, title: '收银台'
        }
    }, {
        path: '/alipay/:orderId', name: 'AlipayRedirectView', component: AlipayRedirectView, meta: {
            auth: false, title: '支付宝收银台'
        }
    },{
        path: '/refund/audit/list', name: 'RefundAuditListView', component: RefundAuditListView, meta: {
            auth: true, title: '退款审批'
        }
    },
    {
        path: '/pay/result/ticket',
        name: 'WxPayResultView',
        component: WxPayResultView,
        meta: {
            auth: false
        }
    },
]

const router = createRouter({
    history: createWebHistory(),
    // history: createWebHashHistory(),
    routes
})

export default router
